import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { FaGithub } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";

const links = ["Home", "About", "Portfolio", "Skills", "Contact"];

const Footer = () => {
  const [repoCount, setRepoCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch("https://api.github.com/users/AakashJha04")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.public_repos != null) {
          setRepoCount(data.public_repos);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <footer className="aurora-section border-t border-slate-200 px-6 py-10 dark:border-zinc-800">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left">
        <div>
          <p className="text-base font-bold text-slate-900 dark:text-white">Aakash Anand</p>
          <p className="mt-1 text-sm text-slate-500 dark:text-zinc-400">
            Software Engineer — Backend, Cloud &amp; AI/LLM Engineering
            {repoCount != null && (
              <>
                {" "}
                · <a
                  href="https://github.com/AakashJha04"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-indigo-600 hover:underline dark:text-indigo-400"
                >
                  {repoCount} public repos on GitHub
                </a>
              </>
            )}
          </p>
        </div>

        <ul className="flex flex-wrap items-center justify-center gap-5 text-sm font-medium text-slate-600 dark:text-zinc-400">
          {links.map((link) => (
            <li key={link}>
              <Link
                to={link}
                smooth
                offset={-64}
                duration={500}
                className="cursor-pointer transition-colors hover:text-indigo-600 dark:hover:text-indigo-400"
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="https://github.com/AakashJha04"
            target="_blank"
            rel="noreferrer me"
            aria-label="GitHub"
            className="grid h-9 w-9 place-items-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:border-indigo-300 hover:text-indigo-600 dark:border-zinc-700 dark:text-zinc-300 dark:hover:text-indigo-400"
          >
            <FaGithub size={16} />
          </a>
          <a
            href="mailto:aakashanand560@gmail.com"
            aria-label="Email"
            className="grid h-9 w-9 place-items-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:border-indigo-300 hover:text-indigo-600 dark:border-zinc-700 dark:text-zinc-300 dark:hover:text-indigo-400"
          >
            <HiOutlineMail size={17} />
          </a>
        </div>
      </div>

      <p className="mt-8 text-center text-xs text-slate-400 dark:text-zinc-600">
        © {new Date().getFullYear()} Aakash Anand. Built with React &amp; Tailwind CSS.
      </p>
    </footer>
  );
};

export default Footer;
